import { render, staticRenderFns } from "./AnalyzePage.vue?vue&type=template&id=2fbca465"
import script from "./AnalyzePage.vue?vue&type=script&lang=js"
export * from "./AnalyzePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports